import {Outlet} from "react-router-dom";
import useCheckLogin from "../hooks/useCheckLogin";

const PrivateRouter = () => {
    const isUserIn = useCheckLogin();

    return isUserIn ? <Outlet/> : null;
};

export default PrivateRouter;
